import * as MixpanelAudience from '../../react/infra/mixpanel/MixpanelAudience';
import * as MixpanelInsights from '../../react/infra/mixpanel/MixpanelInsights';

const BaseWidget = require("../base_widget"),
      c = require("infra/utils/common");

const MAXIMUM_3_MONTHS_MESSAGE = "Maximum date span is three months. Time frame was adjusted.";
const MINIMUM_1_MONTH_MESSAGE = "Minimum date span is one month. Time frame was adjusted.";
const EXPORT_NUMERIC_FORMAT = {'skew': 'numeric', 'distribution': 'percent'};

function TimingWidgetController($scope, $timeout, $element, timingService, util, insightsExportService,
                                examplesDataModel, TIMES, $location, abiPermissions) {

    const self = this;
    this.$scope        = $scope;
    this.util          = util;
    this.TIMES         = TIMES;
    this.$location     = $location;
    this.$timeout      = $timeout;
    this.timingService = timingService;
    this.abiPermissions = abiPermissions;
    this.chartData     = [];
    this.charts        = {};
    this.insightsExportService = insightsExportService;
    this.examplesDataModel = examplesDataModel;

    $scope.compareMode = false;
    $scope.measureTypes = [
        {value: "distribution", label: "Distribution", tooltip: "Consumption breakdown by hour/day"},
        {value: 'skew', label: 'Skew',
         tooltip: "The extent to which the seed interest is over-indexed at a certain hour/day compared to the entire week."}
    ];
    $scope.valueMeasure = 'distribution';
    $scope.compareModeAllowed = false;
    MixpanelInsights.trackPageView('timing');
    const titleTexts = [''].concat(c.getHeatmapHours()).concat('Total');
    const columns = [{width: 15}].concat(Array(25).fill({width: 10}));
    const columnsHourly = [{width: 15}].concat(Array(24).fill({width: 10}));
    const columnsDaily = [{width: 15}].concat(Array(9).fill({width: 10}));
    const days = c.getWeekDays();

    this.onResize = () => $timeout(() => {
        const node = d3.select($element[0]).node();
        $scope.chartWidth = node.offsetWidth - 10;
        $scope.chartHeight = node.offsetHeight;
    });

    function formatOutput(value, format, measure){
        return format(value / 100, EXPORT_NUMERIC_FORMAT[measure]);
    }

    function formatRecordOutput(record, format, measure){
        return formatOutput(_.last(record.vals), format, measure);
    }

    function getTermDisplay(term){
        let termDisplay = term.hasOwnProperty('display') ? term.display : term.text;
        if(c.isString(termDisplay) && termDisplay.endsWith("*")){
            termDisplay = termDisplay.replace(/\*$/," (refined)");
        }
        return termDisplay;
    }

    this.getReportFunctionForSeed = function(term) {
        return function(format){
            const measure = self.$scope.valueMeasure;
            const titles = _.map(titleTexts, _.partial(format, _, 'bold'));
            const timingRecord = self.timingService.getTimingForSeed(term);
            const formatRecordFunction = _.partial(formatRecordOutput, _, format, measure);
            const getDayLine = (dayValue) => {
                const values = _.map(_.filter(timingRecord.days_hours, (rec) => rec.vals[0][0] === dayValue), formatRecordFunction);
                const average = formatRecordFunction(_.find(timingRecord.day_totals, (rec) => rec.vals[0] === dayValue), format);
                return [days[dayValue-1]].concat(values).concat([average]);
            };
            const table = [titles].concat(_.map(_.range(1,8),getDayLine))
                                .concat([['Total'].concat(_.map(timingRecord.hour_totals, formatRecordFunction)).concat([''])]);
            return {name: getTermDisplay(term), columns, table};
        };
    };

    this.getHourlyReport = function(format) {
        let measure = self.$scope.valueMeasure;
        const titles = _.map([''].concat(c.getHeatmapHours()), _.partial(format, _, 'bold'));
        let table = [titles];
        _.each(self.chartData.seeds, function(record){
            const hourRecord = [getTermDisplay(record.term)].concat(_.map(record.hour_totals, _.partial(formatRecordOutput, _, format, measure)));
            table.push(hourRecord);
        });
        table.push(['Total'].concat(_.map(_.map(self.chartData.average_hours, 'vals'), _.partial(formatOutput, _, format, measure))));
        return {name: 'Hourly', columns: columnsHourly, table};
    };

    this.getDailyReport = function(format){
        let measure = self.$scope.valueMeasure;
        const titles = _.map([''].concat(days).concat(['Weekdays','Weekend']), _.partial(format, _, 'bold'));
        let table = [titles];
        const formatOutputFunction = _.partial(formatOutput, _, format, measure);
        _.each(self.chartData.seeds, function(record){
            const day_record = [getTermDisplay(record.term)].concat(_.map(record.day_totals, _.partial(formatRecordOutput, _, format, measure)))
                                                            .concat([formatOutputFunction(record.weekday_total.val), formatOutputFunction(record.weekend_total.val)]);
            table.push(day_record);
        });
        const totals = _.map(self.chartData.average_days, 'vals').concat([self.chartData.average_weekday.val, self.chartData.average_weekend.val]);
        table.push(['Total'].concat(_.map(totals, formatOutputFunction)));
        return {name: 'Daily', columns: columnsDaily, table};
    };

    this.adjustTimeframe = function(changedTimeframe, oldTimeframe, timeAmountUnits) {
        const format = "DD_MM_YY_HH_mm";
        let adjustedTimeframe = angular.copy(oldTimeframe);

        if ((changedTimeframe === undefined || changedTimeframe[1] === 'month' || oldTimeframe[1].substring(0, 8) === changedTimeframe[1].substring(0, 8))
            && moment(oldTimeframe[0], format).add(timeAmountUnits) <= moment().subtract({days : 1})) {
            adjustedTimeframe[1] = moment(oldTimeframe[0], format).add(timeAmountUnits).format(format);
        } else {
            if (moment(oldTimeframe[1], format) > moment().subtract({ days: 1 })) {
                adjustedTimeframe[1] = moment(oldTimeframe[1], format).subtract({'day' : 1}).format(format);
            }
            adjustedTimeframe[0] = moment(oldTimeframe[1], format).subtract(timeAmountUnits).format(format);
        }

        return adjustedTimeframe;
    };

    this.validateTimeframe = function (changedVals) {
        let timeframe = $scope.timeframe;
        let notificationMessage = null;

        if ((timeframe[1] === 'month' && parseInt(timeframe[0]) > 3) || (timeframe[1] === 'year')) {
            $scope.timeframe = [3, 'month'];
            notificationMessage = MAXIMUM_3_MONTHS_MESSAGE;
        } else if (timeframe[1] === 'day') {
            $scope.timeframe = [1, 'month'];
            notificationMessage = MINIMUM_1_MONTH_MESSAGE;
        } else if (timeframe[1] != 'month' && timeframe[1] != 'day') {
            const dateFormat = "DD_MM_YY";

            if (moment(timeframe[0], dateFormat) < moment(timeframe[1], dateFormat).subtract({'month': 3, 'day': c.calcOffsetDays(timeframe, 3)})){
                $scope.timeframe = this.adjustTimeframe(changedVals.timeframe, timeframe, {'month': 3});
                notificationMessage = MAXIMUM_3_MONTHS_MESSAGE;
            } else if (moment(timeframe[0], dateFormat).add({'month': 1}) > moment(timeframe[1], dateFormat)) {
                $scope.timeframe = this.adjustTimeframe(changedVals.timeframe, timeframe, {'month': 1});
                notificationMessage = MINIMUM_1_MONTH_MESSAGE;
            }
        }
        $scope.$root.$broadcast('timeframe-update', $scope.timeframe, true, notificationMessage);
    };

    this.validateContextChannel = function() {
        $scope.$root.context.current.insightsChannels = $scope.insightsChannel = c.getCurrentChannel($scope.insightsChannel, $scope.$root.insightsTimingChannelsFilter, this.abiPermissions);
    };

    this.performUpdate = () => {
        self.$element.append(self.loaderDiv);
        if(this.handler !== undefined && this.handler.noData === undefined) {
            this.handler.promise.cancel();
        }
        this.handler = self.timingService.get(self.parameters);

        if (this.handler.noData === undefined) {
            this.handler.promise.then(data => {
                const heatmap = self.timingService.getHeatmapResult(data, this.handler.termMap, self.parameters.measure)
                drawChart(heatmap);
            }).catch((e) => Promise.reject(e));
            return this.handler.promise;
        } else {
            delete this.handler;
            return Promise.resolve(null);
        }
    };

    function drawChart(data){
        self.loaderDiv.remove();
        $scope.inProcess = false;
        $scope.noData = false;
        let chartArray = [];
        self.chartData = data;
        self.chartData.seeds = _.compact(_.map($scope.terms, (term) => _.find(data.seeds, (seed) => seed.term?.text === term.text)));
        self.charts = {};
        self.insightsExportService.clear();
        self.insightsExportService.setParams(self.parameters);
        self.insightsExportService.setReportFunctions([]);
        if (c.isArray(self.chartData.seeds)) {
            _.each(self.chartData.seeds, function (seed) {
                if (c.is(seed.term)) {
                    const key = c.getKey(seed.term.id, seed.term.text);
                    if (!self.charts[key]) {
                        self.charts[key] = {
                            key,
                            label: seed.term.text,
                            display: self.util.getTermDisplay(seed.term),
                            data: seed.days_hours,
                            day_totals: seed.day_totals,
                            hour_totals: seed.hour_totals,
                            colors: seed.days_hours_colors,
                            day_totals_colors: seed.day_totals_colors,
                            hour_totals_colors: seed.hour_totals_colors
                        };
                        chartArray.push(self.charts[key]);
                        self.insightsExportService.addReportFunction(self.getReportFunctionForSeed(seed.term));
                    }
                }
            });
        }
        $scope.chartArray = chartArray;
        $scope.seedMeasureTopLabel = ($scope.valueMeasure === 'skew') ? ['Overall'] : ['Total'];
        if($scope.chartArray.length <= 1){
            $scope.compareModeAllowed = false;
            $scope.compareMode = false;
        } else {
            $scope.hourlyData = _.pick(self.chartData, 'seeds', 'average_hours', 'average_hours_colors');
            $scope.dailyData = _.pick(self.chartData, 'seeds', 'average_days', 'average_days_colors',
                'average_weekday', 'average_weekday_color', 'average_weekend', 'average_weekend_color');
            const labels = _.map(self.chartData.seeds, ({term}) => self.util.getTermDisplay(term));
            $scope.hourlyData.labels = labels;
            $scope.dailyData.labels = labels;
            self.insightsExportService.addReportFunction(self.getHourlyReport);
            self.insightsExportService.addReportFunction(self.getDailyReport);
            $scope.compareModeAllowed = true;
        }
        self.onResize();
    }

    $scope.updateValueMeasure = (measure) => {
        MixpanelAudience.trackViewChange(measure, 'Timing widget');
        $scope.valueMeasure = measure;
        $scope.inProcess = true;
        $scope.noData = true;
        self.parameters.measure = $scope.valueMeasure;
        self.performUpdate();
    };

    $scope.toggleCompareMode = (value) => $timeout(() => $scope.compareMode = value);

    this.insightsExportService.setTitle('Timing');
}

TimingWidgetController.prototype._doUpdate = function(values, changedVals){
    const self = this;
    const $scope = this.$scope;
    const $location = this.$location;
    self.examplesDataModel.visible = false;
    $scope.inProcess = true;
    $scope.noData = true;
    this.validateContextChannel();
    this.validateTimeframe(changedVals);
    self.parameters = this.util.buildInsightsParameters($scope);
    self.parameters.measure = $scope.valueMeasure;
    if (self.parameters.channel !== "facebook"){
        c.validateNonPhrases($scope.terms, self.parameters.channel, self.notificator);
    }
    if ($location.path() == "/insights/timing") { //Don't set timeframe vars if we're stepping out of widget
        $scope.$root.$broadcast('timeframe-vars-update', ["1M", "3M"], this.TIMES.INSIGHTS_OFFSET, true, false, true);
    }
    return self.performUpdate();
};

TimingWidgetController.$inject = ["$scope", "$timeout", "$element", "timingService", "util", "insightsExportService",
                                  "examplesDataModel", "TIMES", "$location", "abiPermissions"];

module.exports = require("angular").module(__filename, [
    require('data/insights/timing-service').name,
    require('../../common/am-heatmap-chart/heatmap-chart').name,
    require('../../common/am-heatmap-chart/seed-heatmap-chart').name,
    require('../../common/am-heatmap-chart/daily-heatmap-chart').name,
    require('../../common/am-heatmap-chart/hourly-heatmap-chart').name
])
.directive("timingWidget", [function() {
    return BaseWidget({
        restrict: "E",
        template: require('./timing-widget.html'),
        scope: {
            timeframe: "=",
            terms: "=",
            geo: "=",
            sub_geos: "=subGeos",
            topics: "=",
            insightsChannel: '=',
            cacheBaster: '='
        },
        controller: TimingWidgetController
    });
}]);
